import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const GlobalSuccess = [
    {
        name: "Ashna Dhanuka",
        batch: " 2008",
        profession: "Life Coach & Motivational Speaker ",
        location: "Mumbai",
        userImg: "/assets/success/profile1.jpeg",
        text: "This campus gave us knowledge, friendships, and countless memories. Reunions give us a chance to celebrate them all over again."
    },
    {
        name: "Ashyin ",
        batch: " 2007",
        profession: "Head of strategic partnerships  ",
        location: "Gurgaon",
        userImg: "/assets/success/profile2.jpeg",
        text: "One of the best parts of being part of the school alumni program was the chance to reconnect with everyone and share experiences after so many years, it truly felt surreal."
    },
    {
        name: "Shruti Basu ",
        batch: " 2015",
        profession: "Senior Product Designer at Publicis Sapient and a Tattoo Artist  ",
        location: "Gurgaon ",
        userImg: "/assets/success/profile3.jpeg",
        text: "Coming back feels like reliving the best chapter of my life."
    },
    {
        name: "Ayushi Poddar  ",
        batch: " 2022",
        profession: "HOT in Taj Mahal Palace ",
        location: "mumbai ",
        userImg: "/assets/success/profile4.jpeg",
        text: "It's a great experience with VANs and I am recollecting old memories of college."
    },
]


function GlobalSlider() {
    const settings = {
        dots: true, 
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        responsive: [
            {
                breakpoint: 1024, // tablet & small laptop
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640, // mobile
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <>
            <Slider {...settings}>
                {GlobalSuccess?.map((e, i) => {
                    return (
                        <div key={i}>
                            <div
                                className="bg-[#FFFFFF] h-[300px] rounded-[16px] lg:max-w-[96%] max-w-full my-[20px] w-full p-[20px] flex flex-col justify-between"
                                style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}
                            >
                                <div>
                                    <div className="flex gap-[20px] items-start">
                                        <div className="max-w-[64px] w-full">
                                            <img
                                                src={e?.userImg}
                                                className="h-[64px] w-[64px] object-cover rounded-full"
                                                alt=""
                                            />
                                        </div>
                                        <div>
                                            <h6 className="text-[18px] font-playfair font-[600] leading-[28px] text-[#08717D]">
                                                {e?.name}
                                            </h6>
                                            <p className="text-[#4a4a4a] text-[14px] leading-[20px] font-manrope">
                                                Batch of {e?.batch}
                                            </p>
                                            <p className="text-[#d4af37] capitalize text-[14px] leading-[20px] font-[500] font-manrope">
                                                {e?.profession}
                                            </p>
                                        </div>
                                    </div>

                                    <p className="card-content py-[16px]">
                                        {e?.text}
                                    </p>
                                </div>

                                <p className="text-[#d4af37] capitalize text-[14px] leading-[20px] font-[500] font-manrope">
                                    {e?.location}
                                </p>
                            </div>

                        </div>
                    )
                })}
                {/* <div>
                    <div
                        className="bg-[#FFFFFF] rounded-[16px] lg:max-w-[96%] max-w-full my-[20px] w-full p-[20px]"
                        style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}
                    >
                        <div className="flex gap-[20px] items-start">
                            <img
                                src="/assets/hero/img6.avif"
                                className="h-[64px] w-[64px] object-cover rounded-full"
                                alt=""
                            />
                            <div>
                                <h6 className="text-[18px] font-playfair font-[600] leading-[28px] text-[#08717D]">
                                    Ananya Gupta
                                </h6>
                                <p className="text-[#4a4a4a] text-[14px] leading-[20px] font-manrope">
                                    Batch of 2012
                                </p>
                                <p className="text-[#d4af37] text-[14px] leading-[20px] font-[500] font-manrope">
                                    Managing Director, Goldman Sachs
                                </p>
                            </div>
                        </div>
                        <p className="card-content py-[16px]">
                            "VANS connected me with my mentor who guided my Wall Street
                            journey. The sisterhood bond is unbreakable."
                        </p>
                        <div className="flex justify-between items-center">
                            <p className="text-[#d4af37] text-[14px] leading-[20px] font-[500] font-manrope">
                                New York, USA
                            </p>
                            <div className="flex items-center gap-[10px]">
                                <svg
                                    className="w-4 h-4 text-blue-600 mr-1"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                                </svg>
                                <p className="card-content">Verified</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className="bg-[#FFFFFF] rounded-[16px] lg:max-w-[96%] max-w-full my-[20px] w-full p-[20px]"
                        style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}
                    >
                        <div className="flex gap-[20px] items-start">
                            <img
                                src="/assets/hero/img6.avif"
                                className="h-[64px] w-[64px] object-cover rounded-full"
                                alt=""
                            />
                            <div>
                                <h6 className="text-[18px] font-playfair font-[600] leading-[28px] text-[#08717D]">
                                    Ananya Gupta
                                </h6>
                                <p className="text-[#4a4a4a] text-[14px] leading-[20px] font-manrope">
                                    Batch of 2012
                                </p>
                                <p className="text-[#d4af37] text-[14px] leading-[20px] font-[500] font-manrope">
                                    Managing Director, Goldman Sachs
                                </p>
                            </div>
                        </div>
                        <p className="card-content py-[16px]">
                            "VANS connected me with my mentor who guided my Wall Street
                            journey. The sisterhood bond is unbreakable."
                        </p>
                        <div className="flex justify-between items-center">
                            <p className="text-[#d4af37] text-[14px] leading-[20px] font-[500] font-manrope">
                                New York, USA
                            </p>
                            <div className="flex items-center gap-[10px]">
                                <svg
                                    className="w-4 h-4 text-blue-600 mr-1"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                                </svg>
                                <p className="card-content">Verified</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className="bg-[#FFFFFF] rounded-[16px] lg:max-w-[96%] max-w-full my-[20px] w-full p-[20px]"
                        style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}
                    >
                        <div className="flex gap-[20px] items-start">
                            <img
                                src="/assets/hero/img6.avif"
                                className="h-[64px] w-[64px] object-cover rounded-full"
                                alt=""
                            />
                            <div>
                                <h6 className="text-[18px] font-playfair font-[600] leading-[28px] text-[#08717D]">
                                    Ananya Gupta
                                </h6>
                                <p className="text-[#4a4a4a] text-[14px] leading-[20px] font-manrope">
                                    Batch of 2012
                                </p>
                                <p className="text-[#d4af37] text-[14px] leading-[20px] font-[500] font-manrope">
                                    Managing Director, Goldman Sachs
                                </p>
                            </div>
                        </div>
                        <p className="card-content py-[16px]">
                            "VANS connected me with my mentor who guided my Wall Street
                            journey. The sisterhood bond is unbreakable."
                        </p>
                        <div className="flex justify-between items-center">
                            <p className="text-[#d4af37] text-[14px] leading-[20px] font-[500] font-manrope">
                                New York, USA
                            </p>
                            <div className="flex items-center gap-[10px]">
                                <svg
                                    className="w-4 h-4 text-blue-600 mr-1"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                                </svg>
                                <p className="card-content">Verified</p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </Slider>
        </>
    );
}

export default GlobalSlider;
